// Module
var code = "<microsoft-redirect></microsoft-redirect>";
// Exports
module.exports = code;